import React, { Component } from 'react'
import { KeyboardTimePicker as TPicker } from '@material-ui/pickers';

export class TimePicker extends Component{

  handleChange = date => {
    this.props.onChange({
      target: {
        value: date ? date.format('YYYY-MM-DD HH:mm:ssZ') : date
      }
    })
  }

  get value(){
    return this.props.value ? new Date(this.props.value) : null
  }

  render = () =>
    <TPicker
      format="HH:mm"
      {...this.props}
      onChange={this.handleChange}
      value={this.value}
    />

}

export default TimePicker